import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AppNotification } from './notification.interface';

@Injectable({
    providedIn: 'root',
})
export class ToastService {
    private messageSource = new Subject<AppNotification | AppNotification[]>();
    private clearSource = new Subject<string>();

    messageObserver = this.messageSource.asObservable();
    clearObserver = this.clearSource.asObservable();

    add(message: AppNotification) {
        if (message) {
            this.messageSource.next(message);
        }
    }

    addAll(messages: AppNotification[]) {
        if (messages && messages.length) {
            this.messageSource.next(messages);
        }
    }

    clear(key?: string) {
        this.clearSource.next(key||null);
    }
}
